import type { FC } from 'react';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NOT_FOUND_HASH } from 'common/constants';
import { AppRoutes } from 'common/types';
import styles from './NotFoundPage.module.scss';

export const NotFoundPage: FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(NOT_FOUND_HASH);
    //eslint-disable-next-line
  }, []);
  return (
    <div className={styles.notFoundPage}>
      <div className={styles.notFound}>
        <div className={styles.notFoundContent}>
          <h1>
            4<span>0</span>4
          </h1>
        </div>
        <p>
          The page you are looking for might have been removed had its name
          changed or is temporarily unavailable.
        </p>
        <Link to={`${AppRoutes.HOME}`}>Back to home page</Link>
      </div>
    </div>
  );
};
